// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"121f9377","516":"cad93b9f"}[chunkId] + ".chunk.css";
};